import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/admin/user/developers";
const apiTogglle=API_BASE_URL_ENV() + "/admin/user/toggle-activation/Developer"
const apiDropDownEndpoint = API_BASE_URL_ENV() + "/admin/user/dropdown/Developer?status=1";
const exportApi= API_BASE_URL_ENV() + "/admin/user/developers?export=1";
export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
   
    toggleStatus(id, params ={}) {
        return http.get(`${apiTogglle}/${id}` ,{ params });
      }

    getDropDown=()=>{
      return  http.get(apiDropDownEndpoint) 
    }

    getExportUrl = (active, searchWord, locationId) => {
        const obj = JSON.parse(localStorage.getItem("auth"))
        let url = `${exportApi}&token=${obj.access_token}`;
        if (active != 'all')  url =url + `&status=${active === "active" ? 1 : 0}`;
        if (searchWord.trim().length)  url =url + `&keyword=${searchWord}`;
         if (locationId) url =url + `&area_ids=${locationId?.map(loc => loc.value).join()}`
        return url
    }
}